import React, { useContext, useState } from "react";
import { TIPTAP_ACTION_BUTTON_TYPE, TIPTAP_LINK_BUTTON_TYPE } from "./../../ricos-content/index.js";
import { RicosContext } from "./../../ricos-context/index.js";
import { getIsModalOpen, useModalState } from "./../../ricos-modals/modal-service-provider.js";
import { PLUGIN_TOOLBAR_ALIGNMENT_BUTTON } from "../data-hooks.js";
import { DropdownButton } from "../dropdown-button.js";
import { NODE_ALIGNMENT_BUTTONS } from "../node-alignment-dropdown/consts.js";
import { NodeAlignmentDropdown } from "../node-alignment-dropdown/node-alignment-dropdown.js";
import { getNodeAlignment } from "../resolvers/get-node-alignment.js";
import { getNodeInSelection } from "../resolvers/get-node-in-selection.js";
import { getNodeTextWrap } from "../resolvers/get-node-text-wrap.js";
import { isVisibleOnlyOnDesktop } from "../resolvers/is-visible-only-on-desktop.js";
import { PLUGIN_TOOLBAR_BUTTON_ID } from "./plugin-toolbar-buttons-ids.js";
const createNodeAlignmentButton = ({
  services,
  modalId,
  attributes
}) => {
  const isMobile = services.context.isMobile;
  return {
    id: PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT,
    type: "modal",
    attributes: {
      nodeAlignment: getNodeAlignment,
      nodeTextWrap: getNodeTextWrap,
      visible: isVisibleOnlyOnDesktop(isMobile),
      selectedNode: getNodeInSelection,
      active: {
        resolve: (_, { modals }) => Boolean(modals.getModal(modalId))
      },
      ...attributes
    },
    renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeAlignmentButton, { toolbarItem, modalId }),
    dataHook: PLUGIN_TOOLBAR_ALIGNMENT_BUTTON,
    tooltip: "TextAlignmentButton_Tooltip",
    getIcon: ({ services: services2, attributes: attributes2 }) => {
      const selectedAlignment = attributes2.nodeAlignment || (services2.context.languageDir === "rtl" ? "RIGHT" : "LEFT");
      return NODE_ALIGNMENT_BUTTONS[selectedAlignment].icon;
    },
    command: (props) => {
      const { modals, referenceElement, tiptapEditor, attributes: attributes2 } = props;
      modals.isModalOpen(modalId) ? modals.closeModal(modalId) : modals.openModal({
        id: modalId,
        Component: NodeAlignmentDropdown,
        componentProps: {
          nodeId: attributes2.selectedNode?.attrs.id,
          nodeType: attributes2.selectedNode?.type.name,
          modalId,
          onClick: (alignment) => {
            const selectedNode = attributes2.selectedNode;
            tiptapEditor.chain().focus().setNodeAlignment(alignment).command(({ commands }) => {
              const isCustomWidthSpecified = selectedNode?.attrs.containerData?.width?.custom;
              const excludedNodeTypes = [TIPTAP_LINK_BUTTON_TYPE, TIPTAP_ACTION_BUTTON_TYPE];
              if (!isCustomWidthSpecified && !excludedNodeTypes.includes(selectedNode.type.name)) {
                commands.setNodeSize("SMALL");
              }
              return true;
            }).run();
            modals.closeModal(modalId);
          },
          onTextWrapToggle: () => tiptapEditor.chain().focus().toggleNodeTextWrap().run(),
          isTextWrapDisabled: () => !tiptapEditor.can().toggleNodeTextWrap()
        },
        layout: isMobile ? "drawer" : "floating",
        positioning: { referenceElement, placement: "bottom" },
        onClickOutside: {
          on: "pointerup",
          handler: (e) => {
            if (!referenceElement?.contains?.(e.target)) {
              modals.closeModal(modalId);
              return;
            }
          }
        }
      });
    }
  };
};
const NodeAlignmentButton = ({ toolbarItem, modalId }) => {
  const { t, languageDir } = useContext(RicosContext) || {};
  const isModalOpen = useModalState(getIsModalOpen(modalId));
  const [referenceElement, setReferenceElement] = useState(null);
  const getSelectedAlignment = () => toolbarItem?.attributes.nodeAlignment || (languageDir === "rtl" ? "RIGHT" : "LEFT");
  const onClick = (e) => {
    toolbarItem.commands?.click({ referenceElement, e });
  };
  return /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      dataHook: PLUGIN_TOOLBAR_ALIGNMENT_BUTTON,
      active: isModalOpen,
      onClick,
      ref: setReferenceElement,
      icon: NODE_ALIGNMENT_BUTTONS[getSelectedAlignment()].icon,
      tooltip: t("TextAlignmentButton_Tooltip"),
      tabIndex: toolbarItem.presentation.tabIndex
    }
  );
};
export {
  createNodeAlignmentButton
};
//# sourceMappingURL=create-node-alignment-button.js.map
